import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import './styles/global.css';
import './styles/pages.css';

/**
 * Main entry point for the Agent Nexus
 *
 * This file sets up the React application with the necessary providers:
 * - ThemeProvider: Manages the application's theme (light/dark mode)
 * - AuthProvider: Manages authentication state and user session
 * - BrowserRouter: Enables client-side routing
 *
 * The application is wrapped in React.StrictMode to catch potential problems
 * during development and encourage best practices.
 *
 * Global CSS is imported here to ensure styles are applied throughout the app.
 * Page-specific styles are consolidated in pages.css for better maintainability.
 */

// Create a root for the React application
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the application with all necessary providers
root.render(
  <React.StrictMode>
    {/* ThemeProvider enables theme context throughout the app */}
    <ThemeProvider>
      {/* AuthProvider manages user authentication state */}
      <AuthProvider>
        {/* BrowserRouter enables client-side routing */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
); 
